import BuyCreditsPage from './BuyCreditsPage';

export const BuyCredits = () => <BuyCreditsPage />;
